export const PROXY_FONT_ROUTE = '/cdn/proxy/fonts';
export const PROXY_FONT = 'PROXY_FONT';
export const PROXY_FONT_SUCCESS = 'PROXY_FONT_SUCCESS';